import * as queries from './queries';
import * as mutations from './mutations';

export const suppliers = {
  queries: {
    ...queries
  },
  mutations: {
    ...mutations
  }
};
